import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Card, CTAButton, Icon } from '../../tcn/ui-kit';
import { TCN } from '../../tcn/ui-kit/tokens';

/**
 * Module 3 — Biggest gap card.
 *
 * The biggest_gap jsonb on the totals row identifies the worst-performing
 * cell in the 5×10 (5 process metrics × 10 tiers) grid. Pattern from spec:
 *  { tier: 4, metric: 'maintain_completion_pct', value: 33, target: 80,
 *    label: 'Tier 4 maintain completion is at 33% (target 80%)' }
 *
 * CTA opens the Action Log (Module 6) prefilled with source_activity='tier_gap'.
 */
const BiggestGapCard = ({ biggestGap }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (!biggestGap || typeof biggestGap !== 'object') return null;

  const goToActions = () => {
    const params = new URLSearchParams();
    params.set('source', 'tier_gap');
    if (biggestGap.tier != null) params.set('tier', String(biggestGap.tier));
    if (biggestGap.metric) params.set('metric', String(biggestGap.metric));
    if (biggestGap.label) params.set('label', String(biggestGap.label));
    navigate(`/tcn/me/actions?${params.toString()}`);
  };

  return (
    <Card
      padded
      style={{
        padding: 16,
        background: `linear-gradient(135deg, ${TCN.amber}1a, ${TCN.surface1})`,
        border: `1px solid ${TCN.amber}33`,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div
          style={{
            width: 36, height: 36, borderRadius: 10,
            background: `${TCN.amber}33`, color: TCN.amber,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Icon name="warn" size={18} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: 11, fontWeight: 700,
              color: TCN.amber, letterSpacing: '0.08em',
              textTransform: 'uppercase', marginBottom: 4,
            }}
          >
            {t('tcn.m3.biggestGap.label', 'Biggest gap')}
          </div>
          <div style={{ fontSize: 14, color: TCN.text, fontWeight: 600, lineHeight: 1.4 }}>
            {biggestGap.label || t('tcn.m3.biggestGap.fallback', 'Process gap detected')}
          </div>
        </div>
      </div>
      <div style={{ marginTop: 12 }}>
        <CTAButton onClick={goToActions} variant="primary" size="sm" fullWidth>
          {t('tcn.m3.biggestGap.cta', 'Translate into actions')}
        </CTAButton>
      </div>
    </Card>
  );
};

export default BiggestGapCard;
